import { useTranslation } from 'react-i18next';
import { Scale } from 'lucide-react';
import { Page } from '@/components/layout/Page';
import { PageHeader } from '@/components/layout/PageHeader';
import { PageContent } from '@/components/layout/PageContent';

export function LegalNoticePage() {
    const { t } = useTranslation('legal');

    return (
        <Page className="bg-slate-50">
            <PageHeader title={t('legalNotice.title')} backLink="/" width="narrow" />

            <PageContent width="narrow">
                <div className="space-y-6 pb-8">

                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
                        <div className="flex items-center gap-2">
                            <Scale size={18} className="text-emerald-500" />
                            <h2 className="text-sm font-bold text-slate-900">{t('legalNotice.editor.title')}</h2>
                        </div>
                        <div className="text-sm text-slate-600 space-y-1">
                            <p>{t('legalNotice.editor.site')}</p>
                            <p>{t('legalNotice.editor.status')} — {t('legalNotice.editor.name')}</p>
                            <p>{t('legalNotice.editor.email')}</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
                        <h2 className="text-sm font-bold text-slate-900">{t('legalNotice.director.title')}</h2>
                        <p className="text-sm text-slate-600">{t('legalNotice.director.value')}</p>
                    </div>

                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
                        <h2 className="text-sm font-bold text-slate-900">{t('legalNotice.hosting.title')}</h2>
                        <div className="text-sm text-slate-600 space-y-2">
                            <p>{t('legalNotice.hosting.frontend')}</p>
                            <p>{t('legalNotice.hosting.backend')}</p>
                        </div>
                    </div>

                    {(['intellectual', 'liability', 'links', 'applicable'] as const).map((section) => (
                        <div key={section} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-3">
                            <h2 className="text-sm font-bold text-slate-900">{t(`legalNotice.${section}.title`)}</h2>
                            <p className="text-sm text-slate-600 leading-relaxed">{t(`legalNotice.${section}.content`)}</p>
                        </div>
                    ))}

                    <p className="text-xs text-slate-400 text-center pt-2">{t('legalNotice.lastUpdate')}</p>
                </div>
            </PageContent>
        </Page>
    );
}
